<template>
  <div class="mobile-menu d-flex">
    <div
      v-for="route of routes"
      :key="route.name"
    >
      <router-link
        :to="{ name: route.name }"
        class="mobile-menu__item d-flex direction-column align-center"
        active-class="mobile-menu__item--active"
        v-if="route.name"
        exact
      >
        <span class="d-block mb-05 text--large" :class="`${route.icon} ${route.iconClass}`"></span>
        <span class="d-block text--small">{{route.label}}</span>
      </router-link>
      <a
        href="#"
        @click.prevent="openJivo()"
        class="mobile-menu__item d-flex direction-column align-center"
        v-else
      >
        <span class="d-block mb-05 text--large" :class="route.icon"></span>
        <span class="d-block text--small">{{route.label}}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { ShowSettlements, ShowOrders, ShowBills } from '@/mixins/displayRules'
import profile from '@/mixins/profile'

export default {
  mixins: [ShowSettlements, ShowOrders, ShowBills, profile],

  computed: {
    routes () {
      const routeList = [
        {
          icon: 'icon-dashboard',
          label: this.$t('components.Menu.Dashboard'),
          name: 'dashboard',
          iconClass: ''
        },
        {
          icon: 'icon-list',
          label: this.$t('components.Menu.Orders'),
          name: 'orders',
          iconClass: '',
          show: this.ShowOrders
        },
        {
          icon: 'icon-wallet',
          label: this.$t('components.Menu.settlements2'),
          name: 'settlements',
          iconClass: '',
          show: this.ShowSettlements
        },
        {
          icon: 'icon-receipt',
          label: this.$t('components.Menu.bills'),
          name: 'bills',
          iconClass: '',
          show: this.ShowBills && this.profile && !this.profile.prepayment
        },
        // {
        //   icon: 'icon-chat',
        //   label: 'Помощь',
        //   name: 'settlements',
        //   iconClass: ''
        // },
        {
          icon: 'icon-find-out',
          label: this.$t('components.Menu.more'),
          name: 'more',
          iconClass: 'px-1'
        }
      ]

      return routeList.filter(r => r.show || typeof r.show === 'undefined')
    }
  },

  methods: {
    openJivo () {
      // eslint-disable-next-line camelcase,no-undef
      // if (jivo_api) {
      //   // eslint-disable-next-line camelcase,no-undef
      //   jivo_api.open()
      // }
    }
  }
}
</script>

<style lang="scss">
.mobile-menu {
  //padding-left: .5rem;
  //padding-right: .5rem;

  & > * {
    width: 25%;
  }

  &__item {
    padding: 2rem 0 1.5rem 0;

    @include iosPaddingBottom(1.5rem);

    color: $color-space;

    &:link, &:visited {
      color: $color-space
    }

    &--active {
      &:link, &:visited {
        color: $color-secondary;
      }
    }
  }
}
</style>
